export default "__VITE_PUBLIC_ASSET__6f472e00__"